// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/workspace_chats.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.workspace_chats";

export enum WorkspaceChatMode {
  WORKSPACE_CHAT_MODE_UNSPECIFIED = 0,
  WORKSPACE_CHAT_MODE_SCOPING_FIRST = 1,
  WORKSPACE_CHAT_MODE_TRACK_ONLY = 2,
}

export function workspaceChatModeFromJSON(object: any): WorkspaceChatMode {
  switch (object) {
    case 0:
    case "WORKSPACE_CHAT_MODE_UNSPECIFIED":
      return WorkspaceChatMode.WORKSPACE_CHAT_MODE_UNSPECIFIED;
    case 1:
    case "WORKSPACE_CHAT_MODE_SCOPING_FIRST":
      return WorkspaceChatMode.WORKSPACE_CHAT_MODE_SCOPING_FIRST;
    case 2:
    case "WORKSPACE_CHAT_MODE_TRACK_ONLY":
      return WorkspaceChatMode.WORKSPACE_CHAT_MODE_TRACK_ONLY;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkspaceChatMode");
  }
}

export function workspaceChatModeToJSON(object: WorkspaceChatMode): string {
  switch (object) {
    case WorkspaceChatMode.WORKSPACE_CHAT_MODE_UNSPECIFIED:
      return "WORKSPACE_CHAT_MODE_UNSPECIFIED";
    case WorkspaceChatMode.WORKSPACE_CHAT_MODE_SCOPING_FIRST:
      return "WORKSPACE_CHAT_MODE_SCOPING_FIRST";
    case WorkspaceChatMode.WORKSPACE_CHAT_MODE_TRACK_ONLY:
      return "WORKSPACE_CHAT_MODE_TRACK_ONLY";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkspaceChatMode");
  }
}

export interface WorkspaceChatDetails {
  mode: WorkspaceChatMode;
  favorite: boolean;
  action: string;
}

export interface WorkspaceChat {
  id: string;
  companyId: number;
  ownerId: string;
  title: string;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  details: WorkspaceChatDetails | undefined;
}

function createBaseWorkspaceChatDetails(): WorkspaceChatDetails {
  return { mode: 0, favorite: false, action: "" };
}

export const WorkspaceChatDetails: MessageFns<WorkspaceChatDetails> = {
  encode(message: WorkspaceChatDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }
    if (message.favorite !== false) {
      writer.uint32(16).bool(message.favorite);
    }
    if (message.action !== "") {
      writer.uint32(26).string(message.action);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkspaceChatDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkspaceChatDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.favorite = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.action = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkspaceChatDetails {
    return {
      mode: isSet(object.mode) ? workspaceChatModeFromJSON(object.mode) : 0,
      favorite: isSet(object.favorite) ? globalThis.Boolean(object.favorite) : false,
      action: isSet(object.action) ? globalThis.String(object.action) : "",
    };
  },

  toJSON(message: WorkspaceChatDetails): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = workspaceChatModeToJSON(message.mode);
    }
    if (message.favorite !== false) {
      obj.favorite = message.favorite;
    }
    if (message.action !== "") {
      obj.action = message.action;
    }
    return obj;
  },

  create(base?: DeepPartial<WorkspaceChatDetails>): WorkspaceChatDetails {
    return WorkspaceChatDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkspaceChatDetails>): WorkspaceChatDetails {
    const message = createBaseWorkspaceChatDetails();
    message.mode = object.mode ?? 0;
    message.favorite = object.favorite ?? false;
    message.action = object.action ?? "";
    return message;
  },
};

function createBaseWorkspaceChat(): WorkspaceChat {
  return {
    id: "",
    companyId: 0,
    ownerId: "",
    title: "",
    createdAt: undefined,
    updatedAt: undefined,
    details: undefined,
  };
}

export const WorkspaceChat: MessageFns<WorkspaceChat> = {
  encode(message: WorkspaceChat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.ownerId !== "") {
      writer.uint32(26).string(message.ownerId);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.details !== undefined) {
      WorkspaceChatDetails.encode(message.details, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkspaceChat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkspaceChat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ownerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.details = WorkspaceChatDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkspaceChat {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      ownerId: isSet(object.ownerId)
        ? globalThis.String(object.ownerId)
        : isSet(object.owner_id)
        ? globalThis.String(object.owner_id)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      details: isSet(object.details) ? WorkspaceChatDetails.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: WorkspaceChat): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.ownerId !== "") {
      obj.ownerId = message.ownerId;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.details !== undefined) {
      obj.details = WorkspaceChatDetails.toJSON(message.details);
    }
    return obj;
  },

  create(base?: DeepPartial<WorkspaceChat>): WorkspaceChat {
    return WorkspaceChat.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkspaceChat>): WorkspaceChat {
    const message = createBaseWorkspaceChat();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.ownerId = object.ownerId ?? "";
    message.title = object.title ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? WorkspaceChatDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
